import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminAuthGuard } from '../../services/admin-auth-guard';



@Component({
    standalone:true,
    imports:[RouterOutlet],
    providers:[AdminAuthGuard],
    selector: 'admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css']
})

export class AdminComponent {
    collapsed = true;

    toggleCollapsed(): void {
        this.collapsed = !this.collapsed;
        console.log(this.collapsed);
    }

}
